import React from "react";
import { FormControlLabel, Switch } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The shared "Prioritize saved" on/off switch used across the index pages
 * (organizations, events, articles). The switch and label adopt the page's nav
 * accent colour when on; a hidden `::after` clone of the bold label reserves
 * width so toggling the weight doesn't shift surrounding layout.
 */
export default function PrioritizeSavedSwitch({
  show = true,
  checked,
  onChange,
  accentColor,
  sx,
  label = "Prioritize saved"
}) {
  if (!show) return null;
  return /*#__PURE__*/_jsx(FormControlLabel, {
    control: /*#__PURE__*/_jsx(Switch, {
      size: "small",
      checked: checked,
      onChange: event => onChange(event.target.checked),
      sx: theme => ({
        "& .MuiSwitch-switchBase.Mui-checked": {
          color: accentColor
        },
        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
          backgroundColor: alpha(accentColor, theme.palette.mode === "dark" ? 0.45 : 0.55)
        }
      })
    }),
    label: label
    // Switch on the LEFT of its label, matching the other toggles
    // it stacks with in the filter bar. (Was "start", which put
    // this one's switch on the right while its neighbour's sat on
    // the left — the toggles read as alternating sides.)
    ,
    labelPlacement: "end",
    sx: [theme => ({
      m: 0,
      gap: 1,
      "& .MuiFormControlLabel-label": {
        fontWeight: checked ? 600 : 500,
        textTransform: "none",
        color: checked ? accentColor : theme.palette.text.primary,
        "&::after": {
          content: `"${label}"`,
          display: "block",
          fontWeight: 600,
          height: 0,
          overflow: "hidden",
          visibility: "hidden"
        }
      }
    }), ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]
  });
}